import React from "react";
import { ToolRendererProps } from "./types";

export const CreateStoryBoardToolRenderer: React.FC<ToolRendererProps> = ({
  args,
  renderWithErrorIfFailed,
  getFallbackText,
}) => {
  const componentName = args?.componentName || "";
  return componentName
    ? renderWithErrorIfFailed(
        <span className="text-xs text-secondary-n-400">
          Component: {componentName}
        </span>,
      )
    : getFallbackText();
};

export const StorySpecGeneratorToolRenderer: React.FC<ToolRendererProps> = ({
  args,
  renderWithErrorIfFailed,
  getFallbackText,
}) => {
  const storySpecComponentName = args?.componentName || "";
  const storySpecComponentPath = args?.componentPath || "";
  return storySpecComponentName
    ? renderWithErrorIfFailed(
        <span className="text-xs text-secondary-n-400">
          Component: {storySpecComponentName} <br />
          Path: {storySpecComponentPath}
        </span>,
      )
    : getFallbackText();
};

export const CreateOrUpdateStoriesToolRenderer: React.FC<ToolRendererProps> = ({
  args,
  renderWithErrorIfFailed,
}) => {
  const storyComponentName = args?.componentName || "";
  const command = args?.command || "";
  const storyFilePath = args?.storyFilePath || "";

  return (
    <>
      {renderWithErrorIfFailed(
        <div className="text-xs text-secondary-n-400 space-y-1">
          {storyComponentName && (
            <div>
              Component:{" "}
              <span className="font-medium">{storyComponentName}</span>
            </div>
          )}
          {command && (
            <div>
              Action:{" "}
              <span className="font-medium">
                {command === "create" ? "Created" : "Updated"}
              </span>
            </div>
          )}
          {storyFilePath && (
            <div>
              Path: <span className="font-mono">{storyFilePath}</span>
            </div>
          )}
        </div>,
      )}
    </>
  );
};
